(() => {
  if (window.aacaCompactSizeGuideReady) return;
  window.aacaCompactSizeGuideReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-size-guide-close]');
    if (!button) return;
    const guide = button.closest('details.aaca-size-guide');
    if (!guide) return;
    guide.open = false;
    guide.querySelector(':scope > summary')?.focus();
  });
})();
